
const clients = [
    {
        id:null,
        name:'Dakota Rivers',
        instagram:'https://www.instagram.com/dakota.rivers/?igsh=Y3ZhbHU0b2x5Z2Vr',
        tiktok:'https://www.tiktok.com/@dakotarivers',
        youtube:'https://www.youtube.com/@dakotarivers',
        title:"Basketball Content Creator",
        image: process.env.PUBLIC_URL + '/clients/dakotarivers.jpeg',
        brandIDs:[]
    },
    {
        id:null,
        name:'Jordan Bowers',
        instagram:'https://www.instagram.com/jordansbowers/',
        tiktok:'https://www.tiktok.com/@jordansbowers',
        youtube:'',
        title:"Oklahoma Gymnastics",
        image: process.env.PUBLIC_URL + '/clients/jordanbowers.jpg',
        brandIDs:[]
    },
    {
        id:null,
        name:'Sophia Gladieux',
        instagram:'https://www.instagram.com/phiagladieux/',
        tiktok:'https://www.tiktok.com/@phia.gladieux?lang=en',
        youtube:'',
        title:'Penn State Field Hockey',
        image: process.env.PUBLIC_URL + '/clients/sophiagladieux.JPG',
        brandIDs:[]
    },  
    {
        id:null,
        name:'Annie Beard',
        instagram:'https://www.instagram.com/anniecbeard/?hl=en',
        tiktok:'https://www.tiktok.com/@anniecbeard?lang=en',
        youtube:'',
        title:"LSU Gymnastics",
        image: process.env.PUBLIC_URL + '/clients/anniebeard.jpg' ,
        brandIDs:[]
    },
    {
        id:null,
        name:'Alanys Viera',
        instagram:'https://www.instagram.com/alanysvieraa/',
        tiktok:'',
        youtube:'',
        title:"Umiami Women's Volleyball",
        image: process.env.PUBLIC_URL + '/clients/alanysviera.jpeg',
        brandIDs:[]
    },
    {
        id:null,
        name:'Sophia Mancino',
        instagram:'https://www.instagram.com/sofiamancino_/?igsh=MTR1MG41czl4dzc4eg%3D%3D',
        tiktok:'https://www.tiktok.com/@soffmancino?_t=8nrzLLDkJQI&_r=1',
        youtube:'',
        title:"Richmond Women's Soccer",
        image: process.env.PUBLIC_URL + '/clients/sofiamancino.jpeg',
        brandIDs:[]
    },
    {
        id:null,
        name:'Cj Kirker',
        instagram:'https://www.instagram.com/cjkirker/?hl=en',
        tiktok:'https://www.tiktok.com/@cjkirker?lang=en',
        youtube:'',
        title:"Penn State Track & Field",
        image: process.env.PUBLIC_URL + '/clients/cjkirker.jpg' ,
        brandIDs:[]
    },
    {
        id:null,
        name:'Nikki Romano',
        instagram:'https://www.instagram.com/nikki.romano/',
        tiktok:'https://www.tiktok.com/@defnotnikkiroro?lang=en',
        youtube:'',
        title:"Penn State Lionettes",
        image: process.env.PUBLIC_URL + '/clients/nikkiromano.jpg' ,
        brandIDs:[]
    },
    {
        id:null,
        name:'Jessica Leventry',
        instagram:'https://www.instagram.com/jleventry/',
        tiktok:'https://www.tiktok.com/@jessicaleventry?lang=en',
        youtube:'',
        title:"Fitness Creator",
        image: process.env.PUBLIC_URL + '/clients/jessicaleventry.jpg' ,
        brandIDs:[]
    },
    {
        id:null,
        name:'Veronica Zelner',
        instagram:'https://www.instagram.com/theblondeunit/',
        tiktok:'https://www.tiktok.com/@theblondeunit?lang=en',
        youtube:'https://www.youtube.com/@theblondeunit/videos',
        title:"Bikini Athlete",
        image: process.env.PUBLIC_URL + '/clients/veronicazelner.jpg',
        brandIDs:[]
    },
    {
        id:null,
        name:'Danny Dzhaniyev',
        instagram:'https://www.instagram.com/dzhaniyev15/',
        tiktok:'',
        youtube:'',
        title:"Penn State Hockey",
        image: process.env.PUBLIC_URL + '/clients/daniyaldzhaniyev.JPEG' ,
        brandIDs:[]
    },
    {
        id:null,
        name:'Ilana Epstein',
        instagram:'https://www.instagram.com/ilanaeepstein/',
        tiktok:'https://www.tiktok.com/@heyitsilana?lang=en',
        youtube:'',
        title:"Journalist & Content Creator",
        image: process.env.PUBLIC_URL + '/clients/llanaepstein.JPEG',
        brandIDs:[]
    },
    {
        id:null,
        name:'Ben Schoen',
        instagram:'https://www.instagram.com/benschoen19/',
        tiktok:'https://www.tiktok.com/@benschoen19?lang=en',
        youtube:'',
        title:"Penn State Hockey",
        image: process.env.PUBLIC_URL + '/clients/benschoen.jpg' ,
        brandIDs:[]
    },
    {
        id:null,
        name:'Shay Ciezki',
        instagram:'https://www.instagram.com/shay.ciezki/',
        tiktok:'https://www.tiktok.com/@shayciezki',
        youtube:'',
        title:"Indiana Basketball",
        image: process.env.PUBLIC_URL + '/clients/shayciezki.JPEG' ,
        brandIDs:[]
    },
]

export default clients; 